import { render } from "./PresentAddress.vue?vue&type=template&id=c297e446"
import script from "./PresentAddress.vue?vue&type=script&lang=js"
export * from "./PresentAddress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__